import { render, staticRenderFns } from "./List.vue?vue&type=template&id=3c45d1ac&"
import script from "../../models/app-notification/list.ts?vue&type=script&lang=ts&"
export * from "../../models/app-notification/list.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports